export default "__VITE_ASSET__DkYKww7h__ 600w";